import React, { useEffect } from 'react';

/**
 * This component checks for a userInfo object and creates an anonymous 'prc' userInfo if one does not exist.
 * It then renders the passed in {children} element.
 *
 * @param {Object} props - Property object passed into this component
 * @param {UserInfo} props.userInfo - The UserInfo object for the current user
 * @param {Function} props.setUserInfo - The function to call to set UserInfo
 * @param {JSX.Element} props.children - A child JSX element to render after setting the user
 */
export default function PrcWrapper({ userInfo, setUserInfo, children }) {
	useEffect(() => {
		if (!userInfo) {
			setUserInfo({
				type: 'prc'
			});
		}
	}, [setUserInfo, userInfo]);

	return <>{children}</>;
}
